import { useState } from 'react'
import { CS_URL } from '../constants'
import { Row } from './flex'
import { ChevronRightIcon } from './icons'

interface Props {
    onClose: () => void
}

export const MobileNav = ({ onClose }: Props) => {
    const [servicesOpen, setServicesOpen] = useState(false)
    const [aboutUsOpen, setAboutUsOpen] = useState(false)
    const [supportOpen, setSupportOpen] = useState(false)
    const [myAccountOpen, setMyAccountOpen] = useState(false)

    return (
        <>
            <div className="cs-bgnav-background open"></div>
            <nav className="cs-bgnav open">
                <div className="cs-bgnav-home">
                    <a id="p_lt_ctl01_CS_BurgerNavigation_hypSiteURL" href="/">
                        <img
                            id="p_lt_ctl01_CS_BurgerNavigation_imgLogo"
                            className="cs-site-header-logo"
                            src="https://cs-dev-media-01.azureedge.net/mediacontainer/medialibraries/citysprint/citysprint/logo/citysprint.jpeg"
                            alt="Testing"
                        />
                    </a>
                    <div
                        className="cs-bgnav-close-button"
                        onClick={() => {
                            onClose()
                        }}>
                        <span className="icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                viewBox="0 0 37.414 37.414">
                                <defs>
                                    <style>{`.a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}`}</style>
                                </defs>
                                <g transform="translate(0.707 0.707)">
                                    <line className="a" x2="36" y2="36"></line>
                                    <line className="a" x1="36" y2="36"></line>
                                </g>
                            </svg>
                        </span>
                    </div>
                </div>
                <ul>
                    <li>
                        <a href="/">Home</a>
                    </li>
                    <li className="cs-bgnav-has-children">
                        <Row
                            className="cursor-pointer"
                            onClick={() => {
                                setServicesOpen(!servicesOpen)
                                setAboutUsOpen(false)
                                setSupportOpen(false)
                                setMyAccountOpen(false)
                            }}>
                            <a href={`${CS_URL}/courier-services`}>Services</a>
                            <span className="mobile-icon-chevron">
                                <ChevronRightIcon
                                    className={
                                        servicesOpen
                                            ? 'transform rotate-90'
                                            : ''
                                    }
                                />
                            </span>
                        </Row>
                        {servicesOpen && (
                            <ul>
                                <li>
                                    <a href={`${CS_URL}/courier-services`}>
                                        Courier services
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/courier-services/same-day-delivery`}>
                                        Same day courier
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/courier-services/next-day-delivery`}>
                                        Next day delivery
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/courier-services/international-delivery`}>
                                        International delivery
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/courier-services/IT-relocation`}>
                                        IT relocation
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/courier-services/contract-runs`}>
                                        Contract runs
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/courier-services/logistics`}>
                                        Logistics services
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/courier-services/Freight-services`}>
                                        Freight
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/courier-services/in-night`}>
                                        In-night delivery
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/courier-services/specialist-services`}>
                                        Specialist services
                                    </a>
                                </li>

                                <li>
                                    <a href="https://www.citysprintoffice.co.uk/">
                                        CitySprint Office
                                    </a>
                                </li>

                                <li>
                                    <a href="https://www.citysprinthealth.co.uk/">
                                        CitySprint Health
                                    </a>
                                </li>
                            </ul>
                        )}
                    </li>
                    <li className="cs-bgnav-has-children disable">
                        <Row
                            className="cursor-pointer"
                            onClick={() => {
                                setServicesOpen(false)
                                setAboutUsOpen(!aboutUsOpen)
                                setSupportOpen(false)
                                setMyAccountOpen(false)
                            }}>
                            <a href={`${CS_URL}/about-us`}>About us</a>
                            <span className="mobile-icon-chevron">
                                <ChevronRightIcon
                                    className={
                                        servicesOpen
                                            ? 'transform rotate-90'
                                            : ''
                                    }
                                />
                            </span>
                        </Row>
                        {aboutUsOpen && (
                            <ul>
                                <li>
                                    <a href={`${CS_URL}/about-us`}>
                                        Who we are
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/about-us/our-vision`}>
                                        Our vision
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/about-us/our-people`}>
                                        Our people
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/about-us/csr/green`}>
                                        Environmentally friendly delivery
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/about-us/our-fleet`}>
                                        Our fleet
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/about-us/our-customers`}>
                                        Our customers
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/about-us/case-studies`}>
                                        Case studies
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/about-us/awards-and-accreditations`}>
                                        Awards
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/about-us/national-coverage`}>
                                        National coverage
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/about-us/csr`}>CSR</a>
                                </li>

                                <li>
                                    <a
                                        href={`${CS_URL}/about-us/sell-your-business`}>
                                        Selling your business?
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/about-us/technology`}>
                                        Technology
                                    </a>
                                </li>

                                <li>
                                    <a href="https://careers.citysprint.co.uk">
                                        Careers
                                    </a>
                                </li>
                            </ul>
                        )}
                    </li>
                    <li className="cs-bgnav-has-children disable">
                        <Row
                            className="cursor-pointer"
                            onClick={() => {
                                setServicesOpen(false)
                                setAboutUsOpen(false)
                                setSupportOpen(!supportOpen)
                                setMyAccountOpen(false)
                            }}>
                            <a href={`${CS_URL}/support`}>Support</a>
                            <span className="mobile-icon-chevron">
                                <ChevronRightIcon
                                    className={
                                        servicesOpen
                                            ? 'transform rotate-90'
                                            : ''
                                    }
                                />
                            </span>
                        </Row>
                        {supportOpen && (
                            <ul>
                                <li>
                                    <a
                                        href={`${CS_URL}/account/activate-your-online-account`}>
                                        Activate your online account
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/contact-us`}>
                                        Contact us
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/payment-options`}>
                                        Payments &amp; charges
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/track`}>Track</a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/support/resources`}>
                                        Guides &amp; resources
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/brexit`}>
                                        Brexit guidance
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/locations-lookup`}>
                                        Find my local service centre
                                    </a>
                                </li>
                            </ul>
                        )}
                    </li>
                    <li className="">
                        <a href="https://my.citysprint.co.uk/s/company-registration">
                            Sign up for an account
                        </a>
                    </li>
                    <li className="">
                        <a href={`${CS_URL}/couriers`}>Become a courier</a>
                    </li>
                    <li className="cs-bgnav-has-children disable">
                        <Row
                            className="cursor-pointer"
                            onClick={() => {
                                setServicesOpen(false)
                                setAboutUsOpen(false)
                                setSupportOpen(false)
                                setMyAccountOpen(!myAccountOpen)
                            }}>
                            <a href={`${CS_URL}/account/dashboard`}>
                                My account
                            </a>
                            <span className="mobile-icon-chevron">
                                <ChevronRightIcon
                                    className={
                                        servicesOpen
                                            ? 'transform rotate-90'
                                            : ''
                                    }
                                />
                            </span>
                        </Row>
                        {myAccountOpen && (
                            <ul>
                                <li>
                                    <a href={`${CS_URL}/account/sign-in`}>
                                        Sign in
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/account/dashboard`}>
                                        Dashboard
                                    </a>
                                </li>

                                <li>
                                    <a href={`${CS_URL}/session/logout`}>
                                        Sign Out
                                    </a>
                                </li>
                            </ul>
                        )}
                    </li>
                </ul>
            </nav>
        </>
    )
}
